import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import Item from './Item';
import { ItemTypes } from './ItemTypes';
import ListItem from '../ListItem';

const spec = {
    drop(props, monitor, component) {
        // 这里 return 出去的对象属性自行选择，这里只是用 id 作为演示
        return { id: props.id }
    },
    hover(props, monitor, component) {
    },
};

const collect = (connect, monitor) => ({
    // 这里返回一个对象，会将对象的属性都赋到组件的 props 中去。这些属性需要自己定义。
    connectDropTarget: connect.dropTarget(),
});

@DropTarget(ItemTypes.ITEM, spec, collect)
class Container extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
        }
    }
    /**
     * 修改排序
     * @param {Number} dragIndex 拖拽的对象的index值
     * @param {Number} hoverIndex 拖拽结束或鼠标悬浮的对象的index值
     **/
    moveItem = (dragIndex, hoverIndex) => {
        let { data: newData } = this.props;
        console.log("拖拽排序之前的数据", newData);
        const dragItem = newData[dragIndex];
        newData.splice(dragIndex, 1);
        newData.splice(hoverIndex, 0, dragItem);
        console.log("拖拽排序之后的数据", newData);
        this.setState({ data: newData }, () => {
            typeof this.props.onDragEnd === 'function' && this.props.onDragEnd(newData);
        })
    };

    ToHideOneCol(item) {
        let { ToHideOneCol } = this.props;
        ToHideOneCol && ToHideOneCol(item);
    }
    render() {
        const { json = {}, keyWord, data } = this.props;
        return (
            <div
                className="setting-dnd-list"
            >
                {data.map((val, index) => {
                    // 右侧显示排序字段 visible 为true
                    return val.visible &&
                        <Item
                            key={val.id}
                            id={val.id}
                            index={index}
                            type={val.type}
                            moveItem={this.moveItem}
                        >
                            <ListItem
                                key={val.attrcode}
                                keyWord={keyWord}
                                item={val}
                                json={json}
                                ToHideOneCol={item => this.ToHideOneCol(item)}
                            />
                        </Item>;
                },
                )}
            </div>
        );
    }
}
export default Container;